import React, {useEffect, useState} from "react";
import {FlexContainer, LabelText, Spinner, Td} from "../../../../design";
import PDFIcon from "../../../../assets/imgs/pdf.svg";
import {downloadReceiptByReceiptNumber, findSubscriptionV2BillingHistoryById} from "../../../../api";
import currencyformatter from "../../../../utils/currencyformatter";
import getformatteddate from "../../../../utils/getformatteddate";

type Props = {
  id: string,
  timeZone: string
}

const BillingHistory = (props: Props) => {

  const [isShowSpinner, setShowSpinner] = useState(false);
  const [billingHistory, setBillingHistory] = useState([]);

  useEffect(() => {
    const id = props.id;
    if(id) {
      getSubscriptionBillingHistoryById(id);
    }
  }, [props.id]);

  const getSubscriptionBillingHistoryById = async (id) => {
    const value = await findSubscriptionV2BillingHistoryById(id);
    if(value) {
      setBillingHistory(value)
    }
  };

  const divideByHundred = (amount:number) => {
    if(amount && amount > 0) {
      amount /= 100;
      return amount.toFixed(2)
    }
    return amount
  };

  const download = async (receiptNumber) => {
    if(receiptNumber) {
      setShowSpinner(true);
      try {
        const value = await downloadReceiptByReceiptNumber(receiptNumber);
        if(value) {
          const { fileUrl } = value;
          if(fileUrl) {
            window.location = fileUrl;
          }
        }
      } finally {
        setShowSpinner(false);
      }
    }
  };

  return (
    <>
      <div className="px-4">
        <LabelText marginTop="20px" marginBottom="10px" >
          Billing History
        </LabelText>
      </div>
      <hr className="my-2"/>
      <FlexContainer paddingLeft="1rem">
        <table className="table border-0 col-12 col-md-7 col-lg-7 col-xl-5">
          <tbody>
          {
            billingHistory && billingHistory.length > 0 ? (
              billingHistory.map((value, index) => (
                <tr key={index}>
                  <Td hidden={!value.paymentDate} className="border-0" color="#0d0d0d" fontWeight="600" paddingTop=".7rem" paddingBottom=".7rem" paddingRight=".7rem">
                    {props.timeZone && value.paymentDate && getformatteddate(value.paymentDate, props.timeZone)}
                  </Td>
                  <Td hidden={!value.amount} className="border-0" color="#6b6c6f" fontWeight="600" paddingTop=".7rem" paddingBottom=".7rem" paddingRight=".7rem">
                    {value.amount && value.currency && currencyformatter(divideByHundred(value.amount), value.currency.name)}
                  </Td>
                  <Td hidden={!value.receiptNumber} className="border-0" color="#6b6c6f" fontWeight="600">
                    <a style={{cursor: "pointer"}}  onClick={() => download(value.receiptNumber)}>
                      <img src={PDFIcon}  alt=""/>
                    </a>
                  </Td>
                </tr>
              ))
            ): <tr><td className="border-0" colSpan={2}><p className="text-muted">No Data</p></td></tr>
          }
          </tbody>
        </table>
      </FlexContainer>
      <Spinner isOpen={isShowSpinner}/>
    </>
  )
};

export default BillingHistory;
